import { render, staticRenderFns } from "./TabBadgeHeader.vue?vue&type=template&id=45bdf996&scoped=true"
import script from "./TabBadgeHeader.vue?vue&type=script&lang=ts"
export * from "./TabBadgeHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bdf996",
  null
  
)

export default component.exports